export function formatPhone(oldValue, oldSelectionStart) {
  let value = "";
  let selectionStart = oldSelectionStart;
  let i;
  const pattern = "XXX.XXX.XXXX";
  
  // Walk down oldValue copying to value any characters we want to keep.
  for (i=0; i < oldValue.length; i++)
  {
    let currentChar = oldValue.charAt(i);
    let newLength = value.length;

    // Identify the cases where we want to keep the current character.
    if ( (currentChar >= '0' && currentChar <= '9' && newLength < pattern.length && pattern.charAt(newLength) === 'X') ||
         (currentChar >= '2' && currentChar <= '9' && newLength < pattern.length && pattern.charAt(newLength) === 'N') ) {
      value = value + currentChar;
    }
    else if ( (currentChar >= '0' && currentChar <= '9' && newLength < pattern.length && pattern.substring(newLength, newLength+2) === '.X') ||
              (currentChar >= '2' && currentChar <= '9' && newLength < pattern.length && pattern.substring(newLength, newLength+2) === '.N') ) {
      value = value + "." + currentChar;
      // Inserting an extra character in the new string corresponding to just
      // one in the old string means that the cursor position may increment
      // by one.
      if (newLength < selectionStart) {
        selectionStart++;
      }
    }
    else if (newLength < selectionStart) {
      // Inserting zero characters into the new string for one in the old string
      // means the cursor position will decrement by one.
      selectionStart--;
    }
  }

  let returnObj = { value, selectionStart };
  return returnObj;
}

// This function can be used for things like the last four digits of your SSN.
export function formatDigitString(oldValue, oldSelectionStart, maxLength) {
  let value = "";
  let selectionStart = oldSelectionStart;
  let i;

  for (i = 0; i < oldValue.length; i++) {
    let currChar = oldValue.charAt(i);
    let newLength = value.length;

    if (currChar >= '0' && currChar <= '9' && newLength < maxLength) {
      value = value + currChar;
    }
    else if (newLength < selectionStart) {
      selectionStart--;
    }
  }

  let returnObj = { value, selectionStart };
  return returnObj;
}

export function formatZipString(oldZipString) {
  oldZipString = oldZipString.replace(/-/gm, "");
  if (oldZipString.length < 6) {
    return oldZipString;
  } 
  else {
    return `${oldZipString.substring(0, 5)}-${oldZipString.substring(5, oldZipString.length)}`;
  }
}

export function formatCityString(oldCityString) {
  return oldCityString.replace(/[^0-9 a-z A-Z \- ']/g, '');
}